import { render } from "./InterestsEdit.vue?vue&type=template&id=20a94e5a"
import script from "./InterestsEdit.vue?vue&type=script&lang=js"
export * from "./InterestsEdit.vue?vue&type=script&lang=js"

import "./InterestsEdit.vue?vue&type=style&index=0&id=20a94e5a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__